module.exports = __webpack_public_path__ + "img/handbook-explosion_en.37bef8e.jpg";